export default (function (_a) {
    var baseUnit = _a.theme.constants.SIZE_SUB_UNIT, gap = _a.gap, column = _a.column, columnReverse = _a.columnReverse;
    if (typeof gap !== "number") {
        return "";
    }
    var direction = column || columnReverse ? "bottom" : "right";
    return "\n    &> *:not(:last-child) {\n      margin-" + direction + ": " + baseUnit * gap + "px;\n    }\n  ";
});
